import moment from 'moment';
import { Employee } from '@/model/employee';

export function hasLeft(employee: Employee): boolean {
  return !!employee.last_day && moment().isAfter(employee.last_day, 'day');
}

export function isLeaving(employee: Employee): boolean {
  return !!employee.last_day && !hasLeft(employee);
}

export function canBeInvited(employee: Employee): boolean {
  return employee.user_id === null && !employee.last_day;
}

export function formattedLastDay(employee: Employee): string {
  return moment(employee.last_day).format('DD.MM.YYYY');
}
